import { API_URL } from '@/configs/api.config';
import { initTsrReactQuery } from '@ts-rest/react-query/v5';
import { wasticApiContract } from '@packages/contracts';

export const tsrClient = initTsrReactQuery(wasticApiContract, {
	baseUrl:     API_URL ?? 'http://localhost:3000',
	baseHeaders: {
		'x-app-source': 'ts-rest',
		'Content-Type': 'application/json',
	},
	credentials: 'include',
});